// extracted by mini-css-extract-plugin
module.exports = {"pillSwitch":"Pill_pillSwitch__3HfZv","pill":"Pill_pill__37DAw"};